import {
  Box,
  Collapse,
  HStack,
  Image,
  SimpleGrid,
  Stack,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Avatar,
  ModalHeader,
} from "@chakra-ui/react";
import { TiArrowForward } from "react-icons/ti";
import { RiMessage2Fill } from "react-icons/ri";
import React from "react";
import { BsFillStarFill } from "react-icons/bs";
import {
  BsChevronBarDown,
  BsChevronBarUp,
  BsFillCheckCircleFill,
} from "react-icons/bs";
export default function Portfolio() {
  const [more, setMore] = React.useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [image, setImage] = React.useState("");
  const handleImageClick = (imageAddress) => {
    setImage(imageAddress); //This will send the number in state
    onOpen();
  };
  return (
    <>
      <Box borderRadius={10} overflow="hidden">
        <Collapse in={!more} startingHeight={"400px"}>
          <SimpleGrid columns={{ base: 1, md: 2 }} p={10} gap={10}>
            <Stack gap={5}>
              <Image
                src="/images/portfolio/1.png"
                onClick={() => {
                  handleImageClick("1");
                }}
                cursor="pointer"
              />
              <Image
                src="/images/portfolio/2.png"
                onClick={() => {
                  handleImageClick("2");
                }}
                cursor="pointer"
              />
              <Image
                src="/images/portfolio/3.png"
                onClick={() => {
                  handleImageClick("3");
                }}
                cursor="pointer"
              />
            </Stack>
            <Stack gap={5}>
              <Image
                src="/images/portfolio/4.png"
                onClick={() => {
                  handleImageClick("4");
                }}
                cursor="pointer"
              />
              <Image
                src="/images/portfolio/5.png"
                onClick={() => {
                  handleImageClick("5");
                }}
                cursor="pointer"
              />
              <Image
                src="/images/portfolio/6.png"
                onClick={() => {
                  handleImageClick("6");
                }}
                cursor="pointer"
              />
            </Stack>
          </SimpleGrid>
        </Collapse>
        <HStack
          color="brand.500"
          gap={2}
          py={10}
          justify={"center"}
          fontWeight={"medium"}
          fontSize={{ lg: "22px" }}
          cursor="pointer"
          onClick={() => {
            setMore(!more);
          }}
        >
          {more ? <BsChevronBarDown /> : <BsChevronBarUp />}
          <Text>See {more ? "More" : "Less"}</Text>
        </HStack>
      </Box>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size={{ base: "xs", sm: "sm", lg: "xl" }}
        
      >
        <ModalOverlay />
        <ModalContent  maxHeight="90vh"mx={2}>
          <ModalCloseButton
            mt={2}
            mr={{md:6}}
            bg="#c5c5c5"
            color="white"
            borderRadius="20px"
          />
          <ModalHeader>
            <HStack color="brand.500" cursor={"pointer"}>
              <TiArrowForward />
              <RiMessage2Fill />
            </HStack>
          </ModalHeader>
          <ModalBody overflowY="auto" maxHeight="100vh">
            <Stack gap={2}>
              <Stack alignItems="center" gap={2}>
                <Avatar
                  src="/images/marketplace-category/profile/profile-1.png"
                  size="xl"
                />
                <HStack color="#0079BC">
                  <Text fontWeight="bold">Logo Master</Text>
                  <BsFillCheckCircleFill color="#52B9F3" />
                </HStack>
                <HStack>
          <Box color="#FFBE5B">
            <BsFillStarFill />
          </Box>
          <Text fontWeight="bold">4.8</Text>
          <Text color="gray.500" fontWeight="bold">
            (2k)
          </Text>
        </HStack>
                <Button bgColor="brand.500" color="white">
                  View Gig
                </Button>
              </Stack>
              <Image src={"/images/portfolio/" + image + ".png"} />
              <Image
                src={
                  "/images/portfolio/" + (+image === 6 ? 1 : +image + 1) + ".png"
                }
              />
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
